import {
  GET_HIPPODROMES_BET_DETAILS,
  GET_HIPPODROMES_BET_DETAILS_SUCCESS,
  GET_HIPPODROMES_BET_DETAILS_FAILURE,
  HORSE_RACING_WS_PROGRAM_UPDATE,
  SET_SELECTED_PROGRAM_LEG,
  SET_FIXED_ODD_BADGE,
  SET_FIXED_ODD_INFO
} from 'Store/constants';

const initialState = {
  data: {},
  selectedProgramLeg: {},
  firstLegNoRaceNumber: null,
  isLoading: null,
  error: null,
  badge: null,
  infos: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HIPPODROMES_BET_DETAILS:
      return { ...state, isLoading: true, error: null };
    case GET_HIPPODROMES_BET_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        firstLegNoRaceNumber: action.payload.legs[0].legNo,
        isLoading: false,
        error: null
      };
    case GET_HIPPODROMES_BET_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SET_SELECTED_PROGRAM_LEG:
      return { ...state, selectedProgramLeg: action.payload };
    case HORSE_RACING_WS_PROGRAM_UPDATE:
      return {
        ...state,
        data: { ...state.data, legs: action.payload },
        selectedProgramLeg: { index: state.selectedProgramLeg.index, ...action.payload.find(x => +x.legNo === +state.selectedProgramLeg.legNo) },
        isLoading: false, error: null
      };
    case SET_FIXED_ODD_BADGE:
      return { ...state, badge: action.payload };
    case SET_FIXED_ODD_INFO:
      return { ...state, infos: action.payload };

    default:
      return state;
  }
};